<template>
  <div class="News">
    <div class="container_w">
      <bread-crumb :crumbList="crumbList"></bread-crumb>
      <page-header :headerTitle="headerTitle"></page-header>
      <!-- <ul class="news_list_box">
          <li v-for="(item,index) in newsList" :key="index">
              <router-link :to="{path:'/news/newsdetails',query: {fileText: item.fileText,title:item.title}}" class="clear">
                <p class="left">{{item.title}}</p>
                <span class="right">{{item.modifyDt}}</span>
              </router-link>
          </li>
      </ul> -->
      <!-- <div>
          <a-pagination :showQuickJumper="false" simple :defaultCurrent="current" :total="total" />
      </div> -->
      <!-- <div class="clear m-pagination">
        <div class="left" @click="goCheck('previous')" :class="{'prev_dis':prev_dis}"></div>
        <div class="left"><span>{{mCurrent}}</span>/{{mTotal}}</div>
        <div class="left" @click="goCheck('next')" :class="{'next_dis':next_dis}"></div>
      </div> -->


      <div class="clear" style="margin-top:48px;">
        <div class="left">
          <a-menu 
          mode="inline" 
          :default-selected-keys="selectKeys"
          :open-keys="openKeys"
          style="width: 256px;border-right: 0;"
          @click="handleClick"
          @openChange="onOpenChange"
          >
            <template v-for="item in informationData">
              <!-- 第一层 -->
              <a-menu-item :key="item.key" v-if="item.childrens.length>0?item.childrens[0].isNode == 'N'?true:false:true">
                {{item.nodeTitle}}
              </a-menu-item>

              <template v-else>
                <a-sub-menu :key="item.key">
                  <span slot="title"><span>{{item.nodeTitle}}</span></span>
                  <template v-for="list in item.childrens">
                    <!-- 第二层 -->
                    
                    <a-menu-item :key="list.key" v-if="list.childrens.length>0?list.childrens[0].isNode == 'N'?true:false:true">
                      {{list.nodeTitle}}
                    </a-menu-item>
                    <template v-else>
                      <a-sub-menu :key="list.key" :title="list.nodeTitle" class="box_show">
                        <span slot="title"><span>{{list.nodeTitle}}</span></span>
                        <template v-for="sublast in list.childrens">
                          <a-menu-item :key="sublast.key">
                            {{sublast.nodeTitle}}
                          </a-menu-item>
                        </template>
                        
                      </a-sub-menu>
                    </template>
                    
                  </template>
                </a-sub-menu>
              </template>
              
            </template>
          </a-menu>
        </div>
        <div class="right" style="width:832px;">
          <div v-if="isCollapse">
             <a-collapse :bordered="false" expandIconPosition='right' 
              @change="changeActivekey"
              accordion
              >
                <template #expandIcon="props">
                  <a-icon style="color:#BFBFBF;" type="caret-right" :rotate="props.isActive ? -90 : 90" />
                </template>
                <a-collapse-panel 
                v-for="(item,index) in collapesList" 
                :key="index" 
                :header="item.title"
                :style="customStyle"  
                >
                  <!-- <div v-html="item.htmlMsg"></div> -->
                  <div v-html="collapseHtml"></div>
                </a-collapse-panel>
              </a-collapse>
           </div>
          
          <div v-html="detailHtml" class="information_html_box" v-else></div>
        </div>
        

      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
import PageHeader from "@/components/PageHeader/PageHeader";
export default {
  components: {
    BreadCrumb,
    PageHeader,
  },
  name: "News",
  data() {
    return {
      crumbList:[
          {
              name:'News',
              url:''
          }
      ],
      headerTitle:'News',
      newsList:[],
      current:1,
      total:0,
      mCurrent:1,
      mTotal:3,
      prev_dis:false,
      next_dis:false,

      openKeys: ['sub1'],
      selectKeys:['1.1'],
      informationData:[],
      rootSubmenuKeys:[],
      isCollapse:false,
      OfficeID:'',
      collapseHtml:'',
      detailHtml:'',
      customStyle:'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
    };
  },
  props: {},
  watch: {
    '$route' (to, from) {
          // data数据操作
          console.log(to)
          console.log(from)
          
          
          // let menud = this.subCheckData(this.informationData,to.query.key2,to.query.key1)
          // this.informationHtml(menud)
    },
    openKeys(val) {
      console.log('openKeys', val);
    },
  },
  methods: {
    goPrevious(){
      
      console.log(this.mCurrent)
      if(this.mCurrent==1){
        this.mCurrent = 1
        this.prev_dis = true
      }else{
        this.prev_dis = false
        this.mCurrent --
        if(this.mCurrent==1){
          this.prev_dis = true
        }
      }
      
    },
    goNext(){
      
      console.log(this.mCurrent)
      if(this.mCurrent==this.mTotal){
        this.mCurrent = this.mTotal
        this.next_dis = true
      }else{
        this.next_dis = false
        this.mCurrent ++
        if(this.mCurrent==this.mTotal){
          this.next_dis = true
        }
      }
      
    },
    goCheck(v){
      console.log(this.mCurrent)
      if(v == 'previous'){
        if(this.mCurrent==1){
          this.mCurrent = 1
          this.prev_dis = true
          return
        }else{
          this.prev_dis = false
          this.mCurrent --
          if(this.mCurrent==1){
            this.prev_dis = true
          }
        }
      }else{
        if(this.mCurrent==this.mTotal){
          this.mCurrent = this.mTotal
          this.next_dis = true
          return
        }else{
          this.next_dis = false
          this.mCurrent ++
          if(this.mCurrent==this.mTotal){
            this.next_dis = true
          }
        }
      }

      console.log(this.mCurrent)

    },


    changeActivekey(key){
      console.log(key)
      if(key){
        this.$Ajax.get(this.collapesList[key].fileText)
        .then( (response)=> {
            this.collapesList[key].htmlMsg = response.data
            this.collapseHtml = response.data
        })
        .catch( (error) =>{
            console.log(error);
        });
      }
      
    },
    onOpenChange(openKeys) {
      console.log(openKeys)
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    handleClick(e) {
      console.log('click ', e);
      let newData = this.informationData
      let menud = ''
      if(e.keyPath.length >=3){
        // 三级菜单
        menud = this.subCheckData(newData,e.keyPath[0],e.keyPath[1],e.keyPath[2])
      }else if(e.keyPath.length == 1){
        // 三级菜单
        menud = this.subCheckData(newData,e.keyPath[0])
      }else{
        menud = this.subCheckData(newData,e.keyPath[0],e.keyPath[1])
      }
      this.informationHtml(menud)
    },
    
    // key1 点击元素 key2 展开栏 key3 展开栏
    subCheckData(newData,key1,key2,key3){
      console.log(newData)
      let list = []
      let d = {}
      
      console.log(list)
      if(key3 && key2 && key1){
        let newList = []
        for(let i=0;i<newData.length;i++){
          // 第一层for
          if(newData[i].key == key3){
            let list1 = newData[i].childrens

            for(let i1=0;i1<list1.length;i1++){
              // 第二层for
              if(list1[i1].key == key2){
                let newList1 = list1[i1].childrens

                for(let i2=0;i2<newList1.length;i2++){
                  // 第三层for
                  if(newList1[i2].key == key1){
                    d = newList1[i2]
                    break
                  }
                }
                break
              }
            }
            break
          }
        }
        
      }else if(key2 && key1){
        this.openKeys = [key2]
        this.selectKeys  = [key1]
        for(let i=0;i<newData.length;i++){
          if(newData[i].key == key2){
            list = newData[i].childrens
            break
          }
        }
        for(let i=0;i<list.length;i++){
          if(list[i].key == key1){
            d = list[i]
            break
          }
        }
      }else{
        this.openKeys = [key1]
        this.selectKeys  = [key1]
        for(let i=0;i<newData.length;i++){
          if(newData[i].key == key1){
            d = newData[i]
            break
          }
        }
      }
      console.log(d)
      return d
    },
    informationHtml(menud){
      console.log(menud)
      debugger
      if(menud.childrens.length>1){
        // 多条数据 手风琴展示样式
        this.isCollapse = true
        this.collapesList = menud.childrens
      }else{
        var that = this
        this.isCollapse = false
        if(menud.childrens[0].isLink == "Y") {
          window.location.href = menud.childrens[0].linkUrl
        } else {
          this.$Ajax.get(menud.childrens[0].fileText)
          .then( (response)=> {
              this.detailHtml = response.data
          })
          .catch( (error) =>{
              console.log(error);
          });
        }
        
      }
      
    },
    dataFilter(data){
      let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
      console.log(data,'---')
      debugger
      data[0].childrens.forEach((i,k)=>{
        console.log(i)
        if(i.officeIdStr && i.officeIdStr.indexOf(OfficeID) == -1){
          i.splice(k, 1); 
        }else{
          i.childrens||[].forEach((j,e)=>{
            if(j.officeIdStr && j.officeIdStr.indexOf(OfficeID) == -1){
              j.splice(e, 1); 
            }
          })
        }
      })
      console.log(data[0].childrens)
    },
    filtersAjax(value){
      debugger
      this.$Ajax.get(value)
      .then( (response)=> {
          return response.data
      })
      .catch( (error) =>{
          console.log(error);
      });
    },
    filtersText(value) {
      let html = ''
      if (!value) return ''
      debugger
      this.$Ajax.get(value)
      .then( (response)=> {
          value = response.data
      })
      .catch( (error) =>{
          console.log(error);
      });
      return value
    },
    checkdata(detailObjs){
      debugger
      let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
      this.OfficeID = OfficeID

      var returnDetailObjs = detailObjs.concat();
      // returnDetailObjs.forEach((i,k)=>{
      //   if(i.officeIdStr){
      //     if(i.officeIdStr.indexOf(OfficeID) == -1){
      //       detailObjs.splice(k, 1);
      //     }else{
      //       if(i.childrens){
      //         i.childrens.forEach((i1,k1)=>{
      //           if(i1.officeIdStr){
      //             if(i1.officeIdStr.indexOf(OfficeID) == -1){
      //               i.childrens.splice(k1, 1);
      //             }else{
      //               if(i1.childrens){
      //                 // k2
      //                 i1.childrens.forEach((i2,k2)=>{
      //                   if(i2.officeIdStr){
      //                     if(i2.officeIdStr.indexOf(OfficeID) == -1){
      //                       i1.childrens.splice(k2, 1);
      //                     }else{
      //                       // k3
      //                       if(i2.childrens){
      //                         i2.childrens.forEach((i3,k3)=>{
      //                           if(i3.officeIdStr){
      //                             if(i3.officeIdStr.indexOf(OfficeID) == -1){
      //                               i2.childrens.splice(k3, 1);
      //                             }
      //                           }else{
      //                             i2.childrens.splice(k3, 1);
      //                           }
      //                         })
      //                       }
      //                     }
      //                   }else{
      //                      i1.childrens.splice(k2, 1);
      //                   }
      //                 })
      //               }
      //             }
      //           }else{
      //             i.childrens.splice(k1, 1);
      //           }
      //         })
      //       }
      //     }
      //   }else{
      //     returnDetailObjs.splice(k, 1);
      //   }
      // })

        for (var i = 0; i < returnDetailObjs.length; i++) {
            if(returnDetailObjs[i].officeIdStr){
              if(returnDetailObjs[i].officeIdStr.indexOf(OfficeID) == -1){
                returnDetailObjs.splice(i--, 1);
              }else{

                if(returnDetailObjs[i].childrens){
                  for(var j=0;j<returnDetailObjs[i].childrens.length;j++){
                    if(returnDetailObjs[i].childrens[j].officeIdStr){
                      if(returnDetailObjs[i].childrens[j].officeIdStr.indexOf(OfficeID) == -1){
                        returnDetailObjs[i].childrens.splice(j--, 1);
                      }else{

                        if(returnDetailObjs[i].childrens[j].childrens){
                          
                          for(var k = 0;k<returnDetailObjs[i].childrens[j].childrens.length;k++){
                            if(returnDetailObjs[i].childrens[j].childrens[k].officeIdStr){
                              if(returnDetailObjs[i].childrens[j].childrens[k].officeIdStr.indexOf(OfficeID) == -1){
                                returnDetailObjs[i].childrens[j].childrens.splice(k--, 1);
                              }
                            }
                          }
                        }
                      }
                    }else{
                      // 值null全部处理
                      returnDetailObjs[i].childrens.splice(j--, 1);
                    }
                  }
                }
              }
            }else{
              // 值null全部处理
              returnDetailObjs.splice(i--, 1);
            }
            
        }
        return returnDetailObjs;
    }
  },
  filters: {},
  computed: {},
  created() {

    // let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
    // let list = []
    // NEWSJSON[0].childrens.forEach((i)=>{
    //     if(i.officeIdStr){
    //         if(i.officeIdStr.indexOf(OfficeID) >-1){
    //             list.push(i)
    //         }
    //     }
    // })
    // console.log(list)
    // this.newsList = list
    // this.total = list.length


    // this.mTotal=Math.ceil(list.length/10)
    // if(Math.ceil(list.length/10)==1){
    //   this.prev_dis = true
    //   this.next_dis = true
    // }
    


    let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
    this.OfficeID = OfficeID
    let informationlist = []
    
    var rootSubmenuKeys = []
    let newData = this.checkdata(NEWSJSON[0].childrens)
    NEWSJSON[0].childrens = newData
    NEWSJSON[0].childrens.forEach((i,k)=>{
        i.key = `sub${k+1}`
        let key_code = ''
        key_code = `sub${k+1}`
        rootSubmenuKeys.push(key_code)
        console.log(i,k)
        console.log(rootSubmenuKeys)
        if(i.childrens){
          i.childrens.forEach((j,key)=>{
            j.key = `${k+1}.${key+1}`
            if(j.childrens){
              j.childrens.forEach((m,y)=>{
                m.key = `${k+1}.${key+1}.${y+1}`
              })
            }
          })
        }
        
    })
    console.log(NEWSJSON)
    this.rootSubmenuKeys = rootSubmenuKeys
    this.informationData = NEWSJSON[0].childrens
    debugger
    let menud = {}
    if(NEWSJSON[0].childrens[0].childrens[0].isNode == "N"){
      // 单链
      let key1 = NEWSJSON[0].childrens[0].key
      menud = this.subCheckData(NEWSJSON[0].childrens,key1)
    }else{
      menud = this.subCheckData(NEWSJSON[0].childrens,NEWSJSON[0].childrens[0].childrens[0].key,NEWSJSON[0].childrens[0].key)
    }
    
     
    console.log(menud)
    this.informationHtml(menud)
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
.News{
    .container_w{
        padding-bottom: 96px;
        .news_list_box{
            padding-top: 48px;
            padding-bottom: 64px;
            li{
                height:64px;
                border-bottom:1px solid rgba(236,238,240,1);
                padding-top: 22px;
                a{
                  font-size:18px;
                  color:rgba(51,51,51,1);
                }
            }
        }
    }
}
.m-pagination{
  height: 40px;
  div{
    &:nth-child(1),&:nth-child(3){
      cursor: pointer;
      width: 40px;
      height: 40px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &:nth-child(2){
      font-size:18px;
      color:rgba(128,128,128,1);
      line-height:21px;
      margin: 10px 24px 0 24px;
    }
    span{
      color: #D8000F;
    }
    &:nth-child(1){
      background-image: url(../../assets/common/btn_fy_sj_syynormal.png);
      &:hover{
        background-image: url(../../assets/common/btn_fy_sj_syyhover.png);
      }
      &:active{
        background-image: url(../../assets/common/btn_fy_sj_syypress.png);
      }
    }
    &:nth-child(3){
      background-image: url(../../assets/common/btn_fy_nextnormal.png);
      &:hover{
        background-image: url(../../assets/common/btn_fy_nexthover.png);
      }
      &:active{
        background-image: url(../../assets/common/btn_fy_nextpress.png);
      }
    }
    
    // .s{
    //   btn_fy_sj_syydisable
    //   btn_fy_nextdisable
    // }
  }
  .prev_dis{
    background-image: url(../../assets/common/btn_fy_sj_syydisable.png)!important;
  }
  .next_dis{
    background-image: url(../../assets/common/btn_fy_nextdisable.png)!important;
  }
}
</style>
